export function getContainersByHighestAll(smartBay) {
    var _a;
    const containers = [];
    const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();
    // For each stack, get the highest container (top tier)
    for (const stackKey of allStacksKeys) {
        const tiersInStack = allTiersKeys.filter((tier) => { var _a; return (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tier]; });
        if (tiersInStack.length === 0)
            continue;
        // Sort tiers from bottom to top and get the highest (last)
        const sortedTiers = tiersInStack.sort();
        const highestTier = sortedTiers[sortedTiers.length - 1];
        const content = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[highestTier];
        if (content) {
            containers.push(...content.containers);
        }
    }
    return {
        containers,
        tBaysStr: smartBay.tBaysStr,
        level: smartBay.level,
    };
}
